import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

Vue.config.productionTip = false;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/theme.css'; // 全局美化主题
Vue.use(ElementUI);

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import moment from 'moment';
moment.locale('zh-cn');
Vue.prototype.$moment = moment;


import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import jQuery from 'jquery';
// import tac from '@/tac/js/tac.min.js'
Viewer.setDefaults({
	Options: {
		inline: true,
		button: true,
		navbar: true,
		title: true,
		toolbar: true,
		tooltip: true,
		movable: true,
		zoomable: true,
		rotatable: true,
		// "scalable": true,
		transition: true,
		fullscreen: true,
		keyboard: true,
		url: 'data-source'
	}
})

// Vue.prototype.tac = tac;
Vue.prototype.$ = jQuery;
Vue.prototype.$loading = true;
Vue.prototype.$loadingText = '';
Vue.prototype.$breadcrumb = [];

Vue.use(Viewer)

// import VueAMap from 'vue-amap';
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
// 	key: 'cbcb7c74bcbeb6042114aac4a0645fcd',
// 	plugin: [
// 		'AMap.Autocomplete',
// 		'AMap.PlaceSearch',
// 		'AMap.Scale',
// 		'AMap.OverView',
// 		'AMap.ToolBar',
// 		'AMap.MapType',
// 		'AMap.PolyEditor',
// 		'AMap.CircleEditor',
// 		'AMap.Geolocation'
// 	],
// 	v: '1.4.4'
// });

// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
// 	// ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
// 	ak: '5n8tAI8EUkYg4WYfBs2TVn60Qpqmxza3'
// })

// ===== DEV MODE: mock token 已禁用 =====
// 现在后端 TokenFilter 会校验 token 有效性，mock token 无法通过验证。
// 请通过登录页使用真实手机号+密码登录。
// ===== END DEV MODE =====

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')